import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import { PrimaryButton } from '@bibliocommons/base-buttons';
import { openPopUpWindow } from '@bibliocommons/utils-browser';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';

export default function ChatWidgetButton({ widget }) {
  const widgetSrc = `/widgets/chat_widget/${widget}`;

  return (
    <PrimaryButton
      className={`cp-chat-widget-button ${widget}`}
      handleClick={() => openPopUpWindow({ url:widgetSrc, width:300, height:350 })}>
      <span aria-hidden>
        <FormattedMessage id="chat_widget_button_text" />
      </span>
      <ScreenReaderMessage>
        <FormattedMessage id="ada_link_opens_new_window" values={{ linkText: <FormattedMessage id="chat_widget_button_text" /> }} />
      </ScreenReaderMessage>
    </PrimaryButton>
  );
}

ChatWidgetButton.propTypes = {
  widget: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./app/components/search/ChatWidgetButton/ChatWidgetButton.jsx